module.exports = __webpack_public_path__ + "static/media/113.7f04faad.svg";